<template>
    <v-card elevation="4" tile>
        <div class="primary dark">
            <v-card-title class="white--text">
                HERRAMIENTA CUPO NUMERO
            </v-card-title>
            <v-divider/>
            <v-tabs dark background-color="primary" v-model="active">
                <v-tab>REGISTRO</v-tab>
                <v-tab>LISTADO</v-tab>
                <v-tab>BLOQUEO</v-tab>
                <v-tab>SMART ENGINE PANEL</v-tab>
                <v-tab>SMART ENGINE MONITOR</v-tab>
                <v-tab-item>
                    <Register @saved="active = 1"/>
                </v-tab-item>
                <v-tab-item>
                    <List/>
                </v-tab-item>
                <v-tab-item>
                    <Bloqueo/>
                </v-tab-item>
                <v-tab-item>
                    Test
                </v-tab-item>
                <v-tab-item>
                    Testa
                </v-tab-item>
            </v-tabs>
        </div>
    </v-card>
</template>
<script>
import Register from '@components/entities/comercio/cupo-numero/crud';
import List from '@pages/cupo-numero/list.vue';
import Bloqueo from './bloqueo.vue';

export default {
    components: {
        Register,
        List,
        Bloqueo,
    },
    data: function () {
        return {
            active: 0,
        }
    },
    computed: {
    },
    created: function () {
        this.$store.dispatch('ui/layout/setTitle', '');
    },
    methods: {
    },
    watch: {
    },
}
</script>